<script lang="ts" setup>
import MaintenanceImage from '~/assets/maintenance.png';
</script>

<template>
	<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
	<ErrorScreen
		title="Maintenance"
		subtitle="We're currently adding exciting new features and fixing some critical bugs. We'll be back online in just a few minutes!"
		:image="MaintenanceImage"
	/>
</template>
